"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _modal = _interopRequireDefault(require("./modal"));

var _modalHeader = _interopRequireDefault(require("./modal-header"));

var _modalNav = _interopRequireDefault(require("./modal-nav"));

var _modalBody = _interopRequireDefault(require("./modal-body"));

var _modalFooter = _interopRequireDefault(require("./modal-footer"));

var _classNames = _interopRequireDefault(require("@ux/component-utilities/lib/classNames"));

var _useClickOutsideHoc = _interopRequireDefault(require("@ux/component-utilities/lib/use-click-outside-hoc"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * Placeholder component to handle the rendering of the modal dialog.
 *
 * @constructor
 * @public
 */
class ModalComponent extends _modal.default {
  constructor(props = {}) {
    super(...arguments);
    this.backdrop = null;
    this.startTarget = null;
    this.target = props.target;
    this.keydown = this.keydown.bind(this);
    this.onBackgroundClick = this.onBackgroundClick.bind(this);
    this.modalDialog = /*#__PURE__*/(0, _react.createRef)();
  }
  /**
   * The component is mounted in the DOM.
   *
   * @private
   */
  // eslint-disable-next-line max-statements, complexity


  componentDidMount() {
    if (this.state.open === false) {
      return;
    }

    const {
      root
    } = this.props;
    const rootElement = this.root = root || this.modalOuter.getRootNode();
    const target = this.target = this.target || rootElement.querySelector('body') || rootElement; //
    // Store the previous element so we can return focus after modal dialog closes.
    //

    this.previousElement = document.activeElement;

    while (this.previousElement && typeof this.previousElement.focus !== 'function') {
      this.previousElement = this.previousElement.parentElement;
    }

    if (this.modalDialog.current) {
      this.dialogButton = this.modalDialog.current.querySelector('.modal button[data-action="close"]');
    }

    document.addEventListener('keydown', this.keydown);

    if (this.modalDialog.current) {
      const focusableEls = this.modalDialog.current.querySelectorAll('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex]:not([tabindex="-1"])');
      this.focusableEls = Array.prototype.slice.call(focusableEls);
      this.firstFocusableEl = this.focusableEls[0];
      this.lastFocusableEl = this.focusableEls[this.focusableEls.length - 1];
    }

    if (this.dialogButton) {
      this.dialogButton.focus();
    } //
    // Check if we need to render the backdrop correctly.
    //


    if (this.backdrop || this.props.backdrop === false) return; //
    // Generate the placeholder element which is appended to the DOM so we can
    // generate the modal dialog content somewhere else than in our rendered
    // context.
    //

    const backdrop = this.backdrop = document.createElement('div');
    backdrop.classList.add('modal-backdrop', this.props.animate !== false && 'fade'); //
    // Add Linaria style wrapper to HTML to target to ensure the 'global'
    // backdrop element is styled. Also add `modal-open` to the target.
    //

    document.documentElement.classList.add('modal-open');
    target.appendChild(backdrop);
    backdrop.addEventListener('click', this.onBackgroundClick, false); //
    // Now that the element is appended to the body we can fade the backdrop in
    // IF there is reason to animate.
    //

    if (this.props.animate !== false) {
      backdrop.classList.add('show');
    }

    this.insideMouseDown = document.addEventListener('mousedown', e => {
      this.startTarget = e.target;
    }); //
    // We dont want to suppress clicks inside the modal body
    // otherwise things that use @ux/component.outside() will never get the event
    // but we do want to close the modal if the event is outside the modal body
    //

    this.hideHandle = (event, fn) => {
      if (event.target !== this.modalOuter) return;
      if (event.target !== this.startTarget) return;
      if (this.props.disableAutoClose) return;
      document.removeEventListener('click', fn);
      this.close();
    };
  }
  /**
   * Remove the dialog from the DOM.
   *
   * @public
   */
  // eslint-disable-next-line max-statements


  close() {
    if (this.state.open === false) {
      return;
    }

    document.removeEventListener('keydown', this.keydown);

    if (this.hideHandle) {
      document.removeEventListener('click', this.hideHandle);
      this.hideHandle = null;
    }

    document.documentElement.classList.remove('modal-open');

    if (this.backdrop) {
      this.backdrop.removeEventListener('click', this.onBackgroundClick, false);
      this.backdrop.remove();
      this.backdrop = null;
    }

    if (this.previousElement) {
      this.previousElement.focus();
    }

    this.setState({
      open: false
    }, () => {
      if (typeof this.props.onClose === 'function') {
        this.props.onClose(this);
      }
    });
  }
  /**
   * Handle the Tab keydown. Do not allow tabbing in background and set focus.
   *
   * @private
   */


  handleForwardTab() {
    if (document.activeElement === this.lastFocusableEl) {
      event.preventDefault();
      this.firstFocusableEl.focus();
    }
  }
  /**
   * Handle the shift + Tab keydown. Do not allow tabbing in background and set focus.
   *
   * @private
   */


  handleBackwardTab() {
    if (document.activeElement === this.firstFocusableEl) {
      event.preventDefault();
      this.lastFocusableEl.focus();
    }
  }
  /**
   * Handle the closing of the dialog when the ESC key is pressed. Do not allow tabbing in background when modal is open.
   *
   * @param {Event} event DOM Event for the keydown handling.
   * @private
   */


  keydown(event) {
    if (event.key === 'Escape' && this.state.open && !this.props.disableAutoClose) {
      this.close();
    }

    if (event.key === 'Tab' && this.state.open) {
      if (this.focusableEls.length <= 1) {
        event.preventDefault();
      }

      if (event.shiftKey) {
        this.handleBackwardTab();
      } else {
        this.handleForwardTab();
      }

      if (this.lastFocusableEl && (this.lastFocusableEl.disabled || this.lastFocusableEl.tabIndex === -1)) {
        event.preventDefault();
        this.firstFocusableEl.focus();
      }
    }
  }
  /**
   * Render the modal dialog.
   *
   * @returns {React.DOM} Valid DOM.
   * @public
   */


  render() {
    const {
      state,
      props
    } = this;
    const titleForId = typeof props.title === 'string' ? props.title.replace(/[^a-z0-9_-]/gi, '') : Date.now().toString();
    const id = `${titleForId}-modal-dialog`; //
    // The user has closed the dialog, so we shouldn't render anything here. But
    // the render method of React expects something to be returned. The `null`
    // value is the only thing that works here.
    //

    if (state.open === false) {
      return null;
    }

    let ariaLabelledBy;

    if (this.props.header) {
      ariaLabelledBy = this.props['aria-labelledby'];
    } else {
      ariaLabelledBy = `${props.id}-header`;
    }

    let ariaDescribedBy;

    if (this.props.body) {
      ariaDescribedBy = this.props['aria-describedby'];
    } else {
      ariaDescribedBy = `${props.id}-body`;
    }

    return /*#__PURE__*/_react.default.createElement(_useClickOutsideHoc.default, {
      targetRef: this.modalDialog,
      onClick: (event, fn) => {
        if (event.target !== this.modalOuter) return;
        if (event.target !== this.startTarget) return;
        if (this.props.disableAutoClose) return;
        document.removeEventListener('click', fn);
        this.close();
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "modal fade show",
      style: {
        display: 'flex'
      },
      ref: r => {
        this.modalOuter = r;
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      id: id,
      className: (0, _classNames.default)('modal-dialog', props.className)
    }, /*#__PURE__*/_react.default.createElement("div", {
      role: "dialog",
      "aria-modal": "true",
      "aria-labelledby": ariaLabelledBy,
      "aria-describedby": ariaDescribedBy,
      className: 'modal-content',
      ref: this.modalDialog,
      style: props.style
    }, this.baseRender(_modalHeader.default, _modalNav.default, _modalBody.default, _modalFooter.default)))));
  }

}

ModalComponent.propTypes = _objectSpread({}, _modal.default.propTypes); //
// Make importing easier by exposing the individual components to the Modal
// class.
//

const Modal = ModalComponent;
var _default = Modal;
exports.default = _default;
Modal.Header = _modalHeader.default;
Modal.Nav = _modalNav.default;
Modal.Body = _modalBody.default;
Modal.Footer = _modalFooter.default;